import { useEffect, useMemo, useState } from 'react';
import { projectionApi, type ProjectionData } from '../lib/data.js';
import { buildProjectionModel, type ProjectionModel } from '../lib/projection.js';

/**
 * View-model hook for the Projection route: loads /api/projection and derives the
 * chart-ready model (lib/projection.ts) whenever the data changes. Both `data` and
 * `model` are null until the first load resolves.
 */
export function useProjectionModel(): {
  data: ProjectionData | null;
  model: ProjectionModel | null;
  reload: () => Promise<void>;
} {
  const [data, setData] = useState<ProjectionData | null>(null);

  const reload = () => projectionApi.load().then(setData);
  useEffect(() => {
    void reload();
  }, []);

  const model = useMemo(() => (data ? buildProjectionModel(data) : null), [data]);

  return { data, model, reload };
}
